"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Switcher = _interopRequireDefault(require("../Switcher"));
var _types = require("../../types");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class MenuHeader extends _react.PureComponent {
  constructor(...args) {
    super(...args);
    this.handleMenuToggle = () => {
      this.props.toggleCollapsed(!this.props.isExpanded);
    };
  }
  render() {
    return _react.default.createElement(_styles.MenuHeaderContainer, {
      collapsed: !this.props.isExpanded
    }, _react.default.createElement(_styles.MenuHeaderInner, {
      collapsed: !this.props.isExpanded
    }, _react.default.createElement(_styles.MenuToggler, {
      collapsed: !this.props.isExpanded,
      onClick: this.handleMenuToggle
    }, _react.default.createElement("span", null)), this.props.activeSolution.id && _react.default.createElement(_Switcher.default, {
      solutions: this.props.solutions,
      activeSolution: this.props.activeSolution,
      switchLabel: this.props.switchLabel,
      isMenuExpanded: this.props.isExpanded,
      history: this.props.history
    })));
  }
}
MenuHeader.defaultProps = {
  activeSolution: {},
  isExpanded: true
};
var _default = exports.default = MenuHeader;